import { render, staticRenderFns } from "./DBLogs.vue?vue&type=template&id=320951ef&"
import script from "./DBLogs.vue?vue&type=script&lang=js&"
export * from "./DBLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports